import Model from './model.js'

export default class User extends Model {
	static _routeKey = 'user'

	static _attributes = {
		first_name: '',
		last_name: '',
		email: '',
		password: '',
		contact_number_1: '',
		contact_number_2: '',
		contact_number_3: '',
		address_line_1: '',
		address_line_2: '',
		town: '',
		postcode: '',
		job_title: '',
		set_primary_contact: false,
		role_id: (user) => {
			// return user && user.roles.length > 0 ? user.roles[0].id : null

			return null
		},
	}

	_constructor() {
		try {
			this.settings = JSON.parse(this.settings)
		} catch (e) { }
	}

	redirect() {
		console.log('redirect', this.currentView(this.loadSubscription()))

		switch (this.currentView(this.loadSubscription())) {
			case 'zapo':
				return '/subscriptions'
				break
			case 'sign-up':
				if (this.email_verified_at == null) {
					return '/email-verification'
				}

				if (this.sms_verified_at == null) {
					return '/sms-verification'
				}

				return this._redirectSignUp()
				break
			case 'onboarding':
				return this._redirectOnboarding()
				break
			case 'app':
				return '/leads'
				break
		}
	}

	can(p = null) {
		if (this.hasRole('zapo.employee')) {
			return true;
		}

		// console.log(this.crm.plan_id)
		// if (this.crm == null || this.crm.status.status != 'live') {
		// 	return false
		// }

		let pid = {
			pro: 8,
			plus: 7,
			standard: 6,
		}[p]

		if (this.crm.plan_id >= pid || (p == null && this.crm != null)) {
			return true
		}

		return false
	}

	crmOutOfFunds() {
		return false;
		return this.crm_balance <= 0
	}

	crmLink() {
		return this.can() ? '/settings/configuration/' + this.crm.id : false
	}

	currentView(subscription = null) {
		let zapoRoles = this.roles.filter((r) => {
			return r.name.indexOf('zapo.') >= 0
		})

		if (zapoRoles.length > 0) {
			return 'zapo'
		}

		if (subscription == null) {
			subscription = this.loadSubscription()
		}
		console.log(subscription)

		// #TODO: Fix
		switch (true) {
			case this.role == 'sign-up' && this.sign_up_max_step < 6:
				return 'sign-up'
				break
			case this.role == 'onboarding' && (subscription?.status?.value != 'live' || subscription?.subscription_status != 'live'):
				return 'onboarding'
				break
			default:
				return 'app'
				break
		}
	}

	loadSubscription() {
		if (this.subscriptions != undefined && this.subscriptions.length > 0) {
			return this.subscriptions[0]
		}

		return null
	}

	loadSignUpCheck(router) {
		if (this.sign_up_max_step >= 5) {
			router.push(this.redirect())
		}
	}

	_redirectSignUp() {
		if (this.sign_up_max_step == 5) {
			return '/signup/complete'
		}

		switch (this.sign_up_current_step) {
			case 1:
				return '/signup/company'
				break
			case 2:
				return '/signup/product'
				break
			case 3:
				return '/signup/plan'
				break
			case 4:
				return '/signup/payment'
				break
			case 5:
				return '/signup/complete'
				break
		}
	}

	_redirectOnboarding(subscription = null) {
		if (subscription == null) {
			subscription = this.loadSubscription()
		}

		switch (subscription.company.on_boarding_max_step) {
			case 1:
				return '/onboarding/business'
				break
			case 2:
				return '/onboarding/images'
				break
			case 3:
				return '/onboarding/verification'
				break
			case 4:
				return '/onboarding/landing-page'
				break
			case 5:
				return '/onboarding/launch'
				break
		}
	}

	fullName() {
		if (this.first_name == '' || this.first_name == null) {
			return 'Unknown'
		}

		return this.first_name + ' ' + (this.last_name || '')
	}

	rolesString() {
		if (this.role == 'customer') {
			return 'Full access'
		}

		if (this.role == null) {
			return 'Limited access'
		}

		let r = ''

		for (let i = 0; i < this.roles.length; i++) {
			r += this.roles[i].name.replace('customer.', '').replace('zapo.', '')

			if (i + 1 != this.roles.length) {
				r += ', '
			}
		}

		return r
	}

	hasRole(role, like = false) {
		return (
			this.roles.filter((r) => {
				return !like ? r.name == role : r.name.indexOf(role) > -1
			}).length >= 1
		)
	}

	pipelineStage(id) {
		if (id == 0) {
			return {
				name: 'Won',
				color: '#00B885',
			}
		}

		return this.deal_stages.find((s) => parseInt(s.id) == parseInt(id))
	}

	setPipelineStage(position, stage) {
		if (this.settings == null || this.settings.pipeline_stage == null) {
			if (this.settings == null) {
				this.settings = {}
			}

			this.settings.pipeline_stage = ['Quote', 'Won', 'Complete', 'Lost']
		}

		this.settings.pipeline_stage[position] = stage

		return this.settings
	}

	addDefaultFolder(folder) {
		if (folder == null || folder == undefined || folder == '') {
			throw new Error('Folder name cannot be empty')
		}

		if (this.settings.default_folders.findIndex((f) => f.toLowerCase() == folder.toLowerCase()) == -1) {
			this.settings.default_folders.push(folder)
		} else {
			throw new Error('Folder already exists')
		}

		return true
	}

	removeDefaultFolder(name) {
		this.settings.default_folders.splice(
			this.settings.default_folders.findIndex((f) => f.toLowerCase() == name.toLowerCase()),
			1,
		)

		return this.settings
	}

	uploadFolders() {
		if (this.settings == null || this.settings.default_folders == undefined) {
			return ['Documents', 'Images', 'Contracts']
		}

		return this.settings.default_folders
	}

	folders(create = true) {
		let folders = []

		if (create) {
			folders.push({
				value: null,
				html: 'Create new folder',
			})
		}

		folders.push(
			...this.default_folders.map((folder) => {
				return {
					value: folder.id,
					html: this.$vue.$help.capitalizeFirstLetter(folder.name),
				}
			}),
		)

		return folders
	}

	hasAddress() {
		return (
			(this.address_line_1 != '' && this.address_line_1 != null) ||
			(this.address_line_2 != '' && this.address_line_2 != null) ||
			(this.town != '' && this.town != null) ||
			(this.postcode != '' && this.postcode != null)
		)
	}

	static JobTitles() {
		return [
			{ value: 'Managing Director', icon: 'IconStar', iconColor: 'stroke-red-500' }
		];
	}
}
